module.exports = __webpack_public_path__ + "img/people.81da55f3.svg";